/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { SVGProps } from 'react';

export const SocialSharingIcon = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width="24" height="24" fill="white" />
    <path
      d="M18 14C16.8 14 15.7 14.5 15 15.4L9.90002 12.9C10 12.6 10 12.4 10 12.1C10 11.8 10 11.5 9.90002 11.3L15 8.80005C15.7 9.60005 16.8 10.2 18 10.2C20.2 10.2 22 8.39995 22 6.19995C22 3.99995 20.2 2.19995 18 2.19995C15.8 2.19995 14 3.99995 14 6.19995C14 6.49995 14 6.8 14.1 7L9 9.5C8.3 8.7 7.2 8.09998 6 8.09998C3.8 8.09998 2 9.89998 2 12.1C2 14.3 3.8 16.1 6 16.1C7.2 16.1 8.3 15.6 9 14.7L14.1 17.2C14 17.5 14 17.7 14 18C14 20.2 15.8 22 18 22C20.2 22 22 20.2 22 18C22 15.8 20.2 14 18 14ZM18 4C19.1 4 20 4.9 20 6C20 7.1 19.1 8 18 8C16.9 8 16 7.1 16 6C16 4.9 16.9 4 18 4ZM6 14C4.9 14 4 13.1 4 12C4 10.9 4.9 10 6 10C7.1 10 8 10.9 8 12C8 13.1 7.1 14 6 14ZM18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18C20 19.1 19.1 20 18 20Z"
      fill="currentColor"
    />
  </svg>
);
